const store = () => import(/* webpackChunkName: 'calculoconfig-store' */ './src/store')

const ViewWrapper = () => import('./src/views/0000/Main.vue')

const install = function(Vue, options) {
  if (options.lazyStore === undefined || options.lazyStore === false) {
    if (!options.store) {
      throw new Error('Please register the Calculo Configurator Plugin by passing a Vuex Store')
    }

    store().then((storeImport) => {
      options.store.registerModule('calculo', storeImport.default, { preserveState: options.store.state.calculo !== undefined })
    })
  }
}

export default { ViewWrapper, install, store }
